import React, { Component, useEffect, useState } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { Collapse } from 'react-bootstrap';
import { Trans } from 'react-i18next';
import UserService from '../../services/UserService';
import service, { URI } from '../../services/service';
import { useTranslation } from 'react-i18next'
import cookies from 'js-cookie';
import { USER_API } from '../../services/service';
import './SidebarAdmin.css';

const languages = [

  {
    code: 'en',
    name: 'English',
    country_code: 'gb',
  },

  // {
  //   code: 'hi',
  //    name: 'Hindi',
  //    country_code: 'in'
  //  },
  // {
  //   code: 'te',
  //   name: 'Telugu',
  //   country_code: 'in'
  // },
  // {
  //   code: 'pu',
  //   name: 'Punjabi',
  //   country_code: 'in'
  // },
  // {
  //     code : 'mr',
  //     name : 'Marathi',
  //     country_code : 'in'
  // }
]

function Sidebar() {

  const currentLanguageCode = cookies.get('i18next') || 'en'
  const currentLanguage = languages.find((l) => l.code === currentLanguageCode)
  const { t } = useTranslation()

  useEffect(() => {
    document.body.dir = currentLanguage.dir || 'ltr'
    document.title = t('app_title')
  }, [currentLanguage, t])


  useEffect(() => {
    UserService.generateToken();
  }, []);

  const um_api = URI.SERVER?._USER_API;

  const [getstate, setState] = useState({});

  function toggleMenuState(menuState) {
    if (getstate[menuState]) {
      setState({ [menuState]: false });
    } else if (Object.keys(getstate).length === 0) {
      setState({ [menuState]: true });
    } else {
      Object.keys(getstate).forEach(i => {
        setState({ [i]: false });
      });
      setState({ [menuState]: true });
    }
  }

  function onRouteChanged() {
    document.querySelector('#sidebar').classList.remove('active');
    Object.keys(getstate).forEach(i => {
      setState({ [i]: false });
    });

    const dropdownPaths = [
      { path: '/apps', state: 'appsMenuOpen' },
      { path: '/courses', state: 'basicUiMenuOpen' },
      { path: '/users', state: 'advancedUiMenuOpen' },
      { path: '/form-elements', state: 'formElementsMenuOpen' },
      { path: '/testimonials', state: 'tablesMenuOpen' },
      { path: '/maps', state: 'mapsMenuOpen' },
      { path: '/icons', state: 'iconsMenuOpen' },
      { path: '/announcement', state: 'announcementMenuOpen' },
      { path: '/feedback', state: 'feedbackMenuOpen' },
      { path: '/CourseReport', state: 'courseReportMenuOpen' },
      { path: '/emailConfigureSetting', state: 'EmailConfigureMenuOpen' },
      { path: '/charts', state: 'chartsMenuOpen' },
      { path: '/user-pages', state: 'userPagesMenuOpen' },
      { path: '/error-pages', state: 'errorPagesMenuOpen' },
      { path: '/general-pages', state: 'generalPagesMenuOpen' },
      { path: '/ecommerce', state: 'ecommercePagesMenuOpen' },
      { path: '/contactConfigureSetting', state: 'ContactConfigureMenuOpen' },
      { path: '/managingData', state: 'basicRegistrationOperation' },
      { path: '/payment', state: 'PaymentConfigureMenuOpen' },
      { path: '/library', state: 'LibraryAdminOpen' },
      { path: '/nominations', state: 'advancedUiMenuOpenNominations' },
    ];

    dropdownPaths.forEach((obj => {
      if (isPathActive(obj.path)) {
        setState({ [obj.state]: true })
      }
    }));

  }

  function isPathActive(path) {
    return window.location.pathname.startsWith(path);
  }

  function capitalizeFirstLetter(str) {
    let data = `${str}`;
    return data.charAt(0).toUpperCase() + data.slice(1);
  }

  const [headerState, setHeaderState] = useState({
    id: UserService.getUserid(),
    img: um_api + "public/getprofilepic"
  });

  const [getUserDetails, setUserDetails] = useState({});
  let id = UserService.getUserid();

  useEffect(() => {
    onRouteChanged();
    // add class 'hover-open' to sidebar navitem while hover in sidebar-icon-only menu
    const body = document.querySelector('body');
    document.querySelectorAll('.sidebar .nav-item').forEach((el) => {

      el.addEventListener('mouseover', function () {
        if (body.classList.contains('sidebar-icon-only')) {
          el.classList.add('hover-open');
        }
      });
      el.addEventListener('mouseout', function () {
        if (body.classList.contains('sidebar-icon-only')) {
          el.classList.remove('hover-open');
        }
      });
    });

    service.getUserById(id)
      .then(res => {
        setUserDetails(res.data);
      })
      .catch(err => {

      })
  }, [])

  return (
    <div>
      <nav className="sidebar sidebar-offcanvas" id="sidebar">
        <ul className="nav">
          <li className="nav-item nav-profile">
            <a href="!#" className="nav-link" onClick={evt => evt.preventDefault()}>
              <div className="nav-profile-image">
                <img src={`${headerState.img}/${headerState.id}`} alt="profile" />
                <span className="login-status online"></span> {/* change to offline or busy as needed */}
              </div>
              <div className="nav-profile-text">
                <span className="font-weight-bold mb-2"><Trans>{capitalizeFirstLetter(getUserDetails.firstName)} {capitalizeFirstLetter(getUserDetails.lastName)}</Trans></span>
                {/* <span className="text-secondary text-small"><Trans>Project Manager</Trans></span> */}
              </div>
              <i className="mdi mdi-bookmark-check text-success nav-profile-badge"></i>
            </a>
          </li>
          <li className={isPathActive('/AdminDashBoard') ? 'nav-item active' : 'nav-item'}>
            <Link className="nav-link" to="/AdminDashBoard">
              <span className="menu-title"><Trans>{t('dashboard')}</Trans></span>
              <i className="mdi mdi-home menu-icon"></i>
            </Link>
          </li>
          <li className={isPathActive('/admin-configuration') ? 'nav-item active' : 'nav-item'}>
            <Link className="nav-link" to="/admin-configuration">
              <span className="menu-title"><Trans>Configuration Settings</Trans></span>
              <i className="mdi mdi-settings menu-icon"></i>
            </Link>
          </li>
          <li className={isPathActive('/courses') ? 'nav-item active' : 'nav-item'}>
            <div className={getstate.basicUiMenuOpen ? 'nav-link menu-expanded' : 'nav-link'} onClick={() => toggleMenuState('basicUiMenuOpen')} data-toggle="collapse">
              <span className="menu-title"><Trans>{t('courses')}</Trans></span>
              <i className="menu-arrow"></i>
              <i className="mdi mdi-book-open-variant menu-icon"></i>
            </div>
            <Collapse in={getstate.basicUiMenuOpen}>
              <ul className="nav flex-column sub-menu">
                <li className="nav-item">
                  <Link className={isPathActive('/courses/view-courses') ? 'nav-link active' : 'nav-link'} to="/courses/view-courses"><Trans>{t('view_courses')}       </Trans></Link></li>
                {/* <li className="nav-item">  */}
                <li className="nav-item">
                  <Link className={isPathActive('/courses/view-request-learner-for-course') ? 'nav-link active' : 'nav-link'} to="/courses/view-request-learner-for-course"><Trans>{t('learner_request_for_course')}</Trans></Link></li>
                <li className="nav-item">
                  <Link className={isPathActive('/courses/courses-to-publish') ? 'nav-link active' : 'nav-link'} to="/courses/courses-to-publish"><Trans>{t('course_to_publish')}</Trans></Link></li>
                <li className="nav-item"> <Link className={isPathActive('/courses/Course-Details-List') ? 'nav-link active' : 'nav-link'} to="/courses/Course-Details-List"><Trans>{t('course_details_list')}</Trans></Link></li>
                <li className="nav-item"> <Link className={isPathActive('/courses/InstructorCourseList') ? 'nav-link active' : 'nav-link'} to="/courses/InstructorCourseList"><Trans>{t('instructor_course_list')}</Trans></Link></li>
                <li className="nav-item"> <Link className={isPathActive('/courses/AssignOrRemoveInstructors') ? 'nav-link active' : 'nav-link'} to="/courses/AssignOrRemoveInstructors"><Trans>Assign/Remove Instructor</Trans></Link></li>
              </ul>
            </Collapse>
          </li>
          {/* <li className={isPathActive('/library') ? 'nav-item active' : 'nav-item'}>
            <div className={getstate.LibraryAdminOpen ? 'nav-link menu-expanded' : 'nav-link'} onClick={() => toggleMenuState('LibraryAdminOpen')} data-toggle="collapse">
              <span className="menu-title"><Trans>{t('library')}</Trans></span>
              <i className="menu-arrow"></i> <i className="mdi mdi-library menu-icon"></i>
            </div>
            <Collapse in={getstate.LibraryAdminOpen}>
              <ul className="nav flex-column sub-menu">
                <li className="nav-item">
                  <Link className={isPathActive('/library/library-to-publish') ? 'nav-link active' : 'nav-link'} to="/library/library-to-publish"><Trans>{t('library_content_to_publish')}</Trans></Link></li>
                <li className="nav-item">
                  <Link className={isPathActive('/library/view-all-library') ? 'nav-link active' : 'nav-link'} to="/library/view-all-library"><Trans>{t('all_library')}</Trans></Link></li>
                <li className="nav-item">
                  <Link className={isPathActive('/library/request-list') ? 'nav-link active' : 'nav-link'} to="/library/request-list"><Trans>{t('restrict_library')}</Trans></Link></li>
              </ul>
            </Collapse>
          </li> */}
          <li className={isPathActive('/users') ? 'nav-item active' : 'nav-item'}>
            <div className={getstate.advancedUiMenuOpen ? 'nav-link menu-expanded' : 'nav-link'} onClick={() => toggleMenuState('advancedUiMenuOpen')} data-toggle="collapse">
              <span className="menu-title"><Trans>{t('view_users')}</Trans></span>
              <i className="menu-arrow"></i>
              <i className="mdi mdi-account-multiple menu-icon"></i>
            </div>
            <Collapse in={getstate.advancedUiMenuOpen}>
              <ul className="nav flex-column sub-menu">
                <li className="nav-item"> <Link className={isPathActive('/users/non-verified-learners') ? 'nav-link active' : 'nav-link'} to="/users/non-verified-learners"><Trans>Non Verified Learners</Trans></Link></li>
                <li className="nav-item"> <Link className={isPathActive('/users/view-request-learner') ? 'nav-link active' : 'nav-link'} to="/users/view-request-learner"><Trans>Pending Users for Approval</Trans></Link></li>
                <li className="nav-item"> <Link className={isPathActive('/users/view-learners') ? 'nav-link active' : 'nav-link'} to="/users/view-learners"><Trans>View Approved Learner</Trans></Link></li>
                <li className="nav-item"> <Link className={isPathActive('/users/Bulk-User-Registration') ? 'nav-link active' : 'nav-link'} to="/users/Bulk-User-Registration"><Trans>{t('bulk_reg')}</Trans></Link></li>
                <li className="nav-item"> <Link className={isPathActive('/users/assign-instructors') ? 'nav-link active' : 'nav-link'} to="/users/assign-instructors"><Trans>{t('assign_inst')}</Trans></Link></li>
                <li className="nav-item"> <Link className={isPathActive('/users/view-instructors') ? 'nav-link active' : 'nav-link'} to="/users/view-instructors"><Trans>{t('view_instructor')}</Trans></Link></li>
                <li className="nav-item"> <Link className={isPathActive('/users/Bulk-Instructor-Registration') ? 'nav-link active' : 'nav-link'} to="/users/Bulk-Instructor-Registration"><Trans>{t('bulk_inst_upload')}</Trans></Link></li>
              </ul>
            </Collapse>
          </li>
          <li className={isPathActive('/nominations') ? 'nav-item active' : 'nav-item'}>
            <div className={getstate.advancedUiMenuOpenNominations ? 'nav-link menu-expanded' : 'nav-link'} onClick={() => toggleMenuState('advancedUiMenuOpenNominations')} data-toggle="collapse">
              <span className="menu-title"><Trans>{t('nominations')}</Trans></span>
              <i className="menu-arrow"></i>
              <i className="mdi mdi-account-multiple menu-icon"></i>
            </div>
            <Collapse in={getstate.advancedUiMenuOpenNominations}>
              <ul className="nav flex-column sub-menu">
                <li className="nav-item"> <Link className={isPathActive('/nominations/Bulk-User-nomination') ? 'nav-link active' : 'nav-link'} to="/nominations/Bulk-User-nomination"><Trans>Bulk Users Nomination</Trans></Link></li>
                <li className="nav-item"> <Link className={isPathActive('/nominations/Bulk-User-Registration-Nomination') ? 'nav-link active' : 'nav-link'} to="/nominations/Bulk-User-Registration-Nomination"><Trans>Bulk Users Registration & Nomination</Trans></Link></li>
                <li className="nav-item"> <Link className={isPathActive('/nominations/Bulk-User-Nomination-Removal') ? 'nav-link active' : 'nav-link'} to="/nominations/Bulk-User-Nomination-Removal"><Trans>Remove Nominations</Trans></Link></li>
              </ul>
            </Collapse>
          </li>
          <li className={isPathActive('/testimonials') ? 'nav-item active' : 'nav-item'}>
            <div className={getstate.tablesMenuOpen ? 'nav-link menu-expanded' : 'nav-link'} onClick={() => toggleMenuState('tablesMenuOpen')} data-toggle="collapse">
              <span className="menu-title"><Trans>User Submission</Trans></span>
              <i className="menu-arrow"></i>
              <i className="mdi mdi-format-quote-close menu-icon"></i>
            </div>
            <Collapse in={getstate.tablesMenuOpen}>
              <ul className="nav flex-column sub-menu">
                <li className="nav-item"> <Link className={isPathActive('/testimonials/view-testimonials') ? 'nav-link active' : 'nav-link'} to="/testimonials/view-testimonials"><Trans>{t('view_testimonials')}</Trans></Link></li>
                <li className="nav-item"> <Link className={isPathActive('/testimonials/view-screenshots') ? 'nav-link active' : 'nav-link'} to="/testimonials/view-screenshots"><Trans>View ScreenShots</Trans></Link></li>
              </ul>
            </Collapse>
          </li>

          <li className={isPathActive('/announcement') ? 'nav-item active' : 'nav-item'}>
            <div className={getstate.announcementMenuOpen ? 'nav-link menu-expanded' : 'nav-link'} onClick={() => toggleMenuState('announcementMenuOpen')} data-toggle="collapse">
              <span className="menu-title"><Trans>{t('announcement')}</Trans></span>
              <i className="menu-arrow"></i>
              <i className="mdi mdi-bullhorn menu-icon"></i>
            </div>
            <Collapse in={getstate.announcementMenuOpen}>
              <ul className="nav flex-column sub-menu">
                <li className="nav-item"> <Link className={isPathActive('/announcement/General-Announcement') ? 'nav-link active' : 'nav-link'} to="/announcement/General-Announcement"><Trans>{t('general_announcement')}</Trans></Link></li>
                <li className="nav-item"> <Link className={isPathActive('/announcement/event-handling') ? 'nav-link active' : 'nav-link'} to="/announcement/event-handling"><Trans>{t('event_handling')}</Trans></Link></li>
                <li className="nav-item"> <Link className={isPathActive('/announcement/Marquee-for-Header') ? 'nav-link active' : 'nav-link'} to="/announcement/Marquee-for-Header"><Trans>Marquee Notification</Trans></Link></li>
              </ul>
            </Collapse>
          </li>
          <li className={isPathActive('/feedback') ? 'nav-item active' : 'nav-item'}>
            <div className={getstate.feedbackMenuOpen ? 'nav-link menu-expanded' : 'nav-link'} onClick={() => toggleMenuState('feedbackMenuOpen')} data-toggle="collapse">
              <span className="menu-title"><Trans>{t('feedback')}</Trans></span>
              <i className="menu-arrow"></i>
              <i className="mdi mdi-comment menu-icon"></i>
            </div>
            <Collapse in={getstate.feedbackMenuOpen}>
              <ul className="nav flex-column sub-menu">
                <li className="nav-item"> <Link className={isPathActive('/feedback/Feedback-Master') ? 'nav-link active' : 'nav-link'} to="/feedback/Feedback-Master"><Trans>{t('add_master_feedback')}</Trans></Link></li>
              </ul>
            </Collapse>
          </li>

          <li className={isPathActive('/payment') ? 'nav-item active' : 'nav-item'}>
            <div className={getstate.PaymentConfigureMenuOpen ? 'nav-link menu-expanded' : 'nav-link'} onClick={() => toggleMenuState('PaymentConfigureMenuOpen')} data-toggle="collapse">
              <span className="menu-title"><Trans>{t('payment_details')}</Trans></span>
              <i className="menu-arrow"></i> <i className="mdi mdi-cash-multiple menu-icon"></i>
            </div>
            <Collapse in={getstate.PaymentConfigureMenuOpen}>
              <ul className="nav flex-column sub-menu">
                <li className="nav-item"> <Link className={isPathActive('/payment/course-Payment-Details') ? 'nav-link active' : 'nav-link'} to="/payment/course-Payment-Details"><Trans>{t('payment_details_course')}</Trans></Link></li>
                <li className="nav-item"> <Link className={isPathActive('/payment/api-enquiry-from-gateway') ? 'nav-link active' : 'nav-link'} to="/payment/api-enquiry-from-gateway"><Trans>Payment Enquiry and Update</Trans></Link></li>
              </ul>
            </Collapse>
          </li>
          <li className={isPathActive('/CourseReport') ? 'nav-item active' : 'nav-item'}>
            <div className={getstate.courseReportMenuOpen ? 'nav-link menu-expanded' : 'nav-link'} onClick={() => toggleMenuState('courseReportMenuOpen')} data-toggle="collapse">
              <span className="menu-title"><Trans>{t('reports')}</Trans></span>
              <i className="menu-arrow"></i> <i className="mdi mdi-chart-areaspline menu-icon"></i>
            </div>
            <Collapse in={getstate.courseReportMenuOpen}>
              <ul className="nav flex-column sub-menu">
                <li className="nav-item"> <Link className={isPathActive('/CourseReport/Learners-Report') ? 'nav-link active' : 'nav-link'} to="/CourseReport/Learners-Report"><Trans>{t('learners_report')}</Trans></Link></li>
                <li className="nav-item"> <Link className={isPathActive('/CourseReport/course-learner-and-fees-status') ? 'nav-link active' : 'nav-link'} to="/CourseReport/course-learner-and-fees-status"><Trans>{t('registration_report')}</Trans></Link></li>
                <li className="nav-item"> <Link className={isPathActive('/CourseReport/enrollement-report') ? 'nav-link active' : 'nav-link'} to="/CourseReport/enrollement-report"><Trans>Enrollement Report</Trans></Link></li>
                <li className="nav-item"> <Link className={isPathActive('/CourseReport/Course-Analytics-Report') ? 'nav-link active' : 'nav-link'} to="/CourseReport/Course-Analytics-Report"><Trans>Course Analytic Report</Trans></Link></li>
                <li className="nav-item"> <Link className={isPathActive('/CourseReport/course-summary') ? 'nav-link active' : 'nav-link'} to="/CourseReport/course-summary"><Trans>Course Summary Report</Trans></Link></li>
                <li className="nav-item"> <Link className={isPathActive('/CourseReport/nfsu-template-report') ? 'nav-link active' : 'nav-link'} to="/CourseReport/nfsu-template-report"><Trans>Template Report</Trans></Link></li>
                <li className="nav-item"> <Link className={isPathActive('/CourseReport/complete-report') ? 'nav-link active' : 'nav-link'} to="/CourseReport/complete-report"><Trans>Course Detailed Summary Report</Trans></Link></li>
                <li className="nav-item"> <Link className={isPathActive('/CourseReport/coursewise-learnerlist') ? 'nav-link active' : 'nav-link'} to="/CourseReport/coursewise-learnerlist" ><Trans>Course Wise User Details and Quiz Report</Trans></Link></li>
                <li className="nav-item"> <Link className={isPathActive('/CourseReport/others-reports') ? 'nav-link active' : 'nav-link'} to="/CourseReport/others-reports"><Trans>{t('others_reports')}</Trans></Link></li>
              </ul>
            </Collapse>
          </li>
          <li className={isPathActive('/managingData') ? 'nav-item active' : 'nav-item'}>
            <div className={getstate.basicRegistrationOperation ? 'nav-link menu-expanded' : 'nav-link'} onClick={() => toggleMenuState('basicRegistrationOperation')} data-toggle="collapse">
              <span className="menu-title"><Trans>{t('manage_reg')}</Trans></span>
              <i className="menu-arrow"></i>
              <i className="mdi mdi-account-multiple menu-icon"></i>
            </div>
            <Collapse in={getstate.basicRegistrationOperation}>
              <ul className="nav flex-column sub-menu">
                <li className="nav-item"> <Link className={isPathActive('/managingData/manage-designation') ? 'nav-link active' : 'nav-link'} to="/managingData/manage-designation"><Trans>{t("manage_designation")}</Trans></Link></li>
                <li className="nav-item"> <Link className={isPathActive('/managingData/manage-qualification') ? 'nav-link active' : 'nav-link'} to="/managingData/manage-qualification"><Trans>{t('manage_qualification')}</Trans></Link></li>
              </ul>
            </Collapse>
          </li>

        </ul>
      </nav>
    </div>
  );
}
export default Sidebar;
